import React, { useState } from 'react';
import s from './Subscription.module.css';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import SubscriptionConfirmationModal from './SubscriptionConfirmationModal';

interface UpgradeButtonProps {
    product: any | null;
    autoRenew: boolean;
}

export default function UpgradeButton({ product, autoRenew }: UpgradeButtonProps) {
    const [loading, setLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const subscription = useSelector((state: RootState) => state.subscription.userSubscription);

    const currentTier = subscription?.tier ?? 0;
    const productTier = Number(product?.attributes?.metadata?.tier ?? 0);

    const rawPlan = product?.attributes?.metadata?.plan || product?.attributes?.name || 'Plan';
    const productLabel = rawPlan.charAt(0).toUpperCase() + rawPlan.slice(1);

    let buttonLabel = 'Upgrade';
    let actionType: 'upgrade' | 'downgrade' | 'manage' = 'upgrade';

    if (currentTier === productTier) {
        buttonLabel = 'Manage Plan';
        actionType = 'manage';
    } else if (productTier < currentTier) {
        buttonLabel = `Downgrade to ${productLabel}`;
        actionType = 'downgrade';
    } else if (productTier > currentTier) {
        buttonLabel = `Upgrade to ${productLabel}`;
        actionType = 'upgrade';
    }

    return (
        <>
            <button
                className={s.upgradeBtn}
                disabled={loading || !product}
                aria-busy={loading}
                onClick={() => setIsOpen(true)}
            >
                {loading
                    ? actionType === 'manage'
                        ? 'Opening portal…'
                        : actionType === 'downgrade'
                          ? 'Downgrading…'
                          : 'Upgrading…'
                    : buttonLabel}
            </button>

            <SubscriptionConfirmationModal
                product={product}
                autoRenew={autoRenew}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
            />
        </>
    );
}
